/* eslint-disable react/no-array-index-key */
import { Input, Spinner } from '@nextui-org/react';
import React from 'react';
import RegisterCubage from '../../components/RegisterCubage/RegisterCubage';
import CubageTable from './CubageTable/CubageTable';
import useCubage from './hooks/useCubage';

const Cubage = (): JSX.Element => {
  const { handleGetCubages, loading, cubages, modalRef, setFilter } =
    useCubage();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-end justify-between">
        <p className="text-default-500">
          Selecione uma cubagem para ver seus detalhes ou edita-la:
        </p>

        <div className="grid grid-cols-2 items-end gap-8 ">
          <Input
            size="md"
            type="text"
            label="Filtro"
            variant="underlined"
            placeholder="EAN"
            autoFocus
            classNames={{
              label: 'font-bold',
            }}
            onValueChange={(value) => {
              setFilter(value);
            }}
          />

          <RegisterCubage
            useModalStyle
            onUpdate={handleGetCubages}
            ref={modalRef}
          />
        </div>
      </div>

      {loading && <Spinner label="Baixando conteúdo" color="default" />}

      {!loading && (
        <CubageTable
          cubages={cubages}
          onRowClick={(cubage) => modalRef.current?.openToEdit(cubage)}
        />
      )}
    </div>
  );
};

export default Cubage;
